// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Sesiones TE: create compuesto + endpoints anidados (admin-transfer-sessions.md).

export const transferPaths = {
    sessions:     ()         => 'admin/transfer-sessions',
    session:      (id)       => `admin/transfer-sessions/${id}`,
    // Read derivado: sesiones TE asociadas a una OPU + pool para reanudar
    // (decisión 0019; vive bajo aspiration-sessions).
    opuSessions:  (opuId)    => `admin/aspiration-sessions/${opuId}/transfer-sessions`,
    staff:        (id)       => `admin/transfer-sessions/${id}/staff`,
    staffItem:    (id, sId)  => `admin/transfer-sessions/${id}/staff/${sId}`,
    transfers:    (id)       => `admin/transfer-sessions/${id}/transfers`,
    transferItem: (id, tId)  => `admin/transfer-sessions/${id}/transfers/${tId}`,
};
